

import hooks from '../../actions/hooks';

import { setRules, setRulesStatus } from './';
import { setTempRules, setSaved } from './tempRules';


export const saveRules = (token) => async (dispatch, getState) => {
	// console.log("did we get a token:", token);
	const { tempRules } = getState();
	dispatch(setRulesStatus('saving_changes'));
	try {
		await hooks.put('/update/rules', tempRules.list, token);
		dispatch(setRulesStatus('changes_saved'));
		setTimeout(function() {
			dispatch(setRulesStatus('dormant'));
			dispatch(setSaved());
		}, 1500);
	} catch (error) {
		dispatch(restoreRules());
		console.error("\txx error saving rules:", error);
	}
};



export const restoreRules = () => (dispatch, getState) => {
	const currentRules = getState().rules.list;
	dispatch(setTempRules(currentRules));
	dispatch(setRulesStatus('restored'));
	setTimeout(() => dispatch(setRulesStatus('dormant')), 0);
};


export const setBothRules = (rules) => (dispatch) => {
	dispatch(setRules(rules));
	dispatch(setTempRules(rules));
};


export const clearRuleAlert = (rule_id, token) => async (dispatch) => {
	try {
		await hooks.put(`/update/rule-alert/${rule_id}/clear`, {}, token);
		// No Redux update needed here — the MQTT round-trip from settings
		// will publish rules/updated, which setBothRules will handle automatically
	} catch (err) {
		console.error('\txx error clearing rule alert:', err);
	}
};